
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93jOkmaf4TUGMeta } from "/var/www/website/frontend/pages/[...slug].vue?macro=true";
import { default as cookiesaF9eqnjq1HMeta } from "/var/www/website/frontend/pages/cookies.vue?macro=true";
import { default as _91_46_46_46slug_93klmhRUSIAvMeta } from "/var/www/website/frontend/pages/cursus-opleiding/[...slug].vue?macro=true";
import { default as indexDxegQRugRpMeta } from "/var/www/website/frontend/pages/cursus-opleiding/index.vue?macro=true";
import { default as indexe8u1OeSfvKMeta } from "/var/www/website/frontend/pages/index.vue?macro=true";
import { default as checkMJIWtDgwsrMeta } from "/var/www/website/frontend/pages/inloggen/check.vue?macro=true";
import { default as index04ZZ0sTMoMMeta } from "/var/www/website/frontend/pages/inloggen/index.vue?macro=true";
import { default as _91_46_46_46slug_93trwdE7UiF4Meta } from "/var/www/website/frontend/pages/jgz/[...slug].vue?macro=true";
import { default as indexAkt1cfyWHiMeta } from "/var/www/website/frontend/pages/jgz/index.vue?macro=true";
import { default as _91_46_46_46slug_933GvE6zvmBBMeta } from "/var/www/website/frontend/pages/maa/[...slug].vue?macro=true";
import { default as indexbPlDFxWz5kMeta } from "/var/www/website/frontend/pages/maa/index.vue?macro=true";
import { default as _91_46_46_46slug_93pnA18A5KmIMeta } from "/var/www/website/frontend/pages/nieuws/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93aXtRcgSGGmMeta } from "/var/www/website/frontend/pages/nieuws/categorie/[...slug].vue?macro=true";
import { default as index00DA9PyB3UMeta } from "/var/www/website/frontend/pages/nieuws/index.vue?macro=true";
import { default as _91_46_46_46slug_930kkwf54JOrMeta } from "/var/www/website/frontend/pages/nieuws/tag/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_938hooQ20G6bMeta } from "/var/www/website/frontend/pages/nt2/[...slug].vue?macro=true";
import { default as indexW7NVrCKXReMeta } from "/var/www/website/frontend/pages/nt2/index.vue?macro=true";
import { default as _91_46_46_46slug_93dEbGjAMWMjMeta } from "/var/www/website/frontend/pages/studiewijzer/[...slug].vue?macro=true";
import { default as indexFCfOakJh74Meta } from "/var/www/website/frontend/pages/studiewijzer/index.vue?macro=true";
import { default as aanmeldenDTMqV8rSqeMeta } from "/var/www/website/frontend/pages/winkelwagen/aanmelden.vue?macro=true";
import { default as afrekenen2ZwbE72W3UMeta } from "/var/www/website/frontend/pages/winkelwagen/afrekenen.vue?macro=true";
import { default as bedanktA8jL7ePLFmMeta } from "/var/www/website/frontend/pages/winkelwagen/bedankt.vue?macro=true";
import { default as geannuleerdtgTxsaas0wMeta } from "/var/www/website/frontend/pages/winkelwagen/geannuleerd.vue?macro=true";
import { default as geweigerdfVpv32LB0WMeta } from "/var/www/website/frontend/pages/winkelwagen/geweigerd.vue?macro=true";
import { default as indexjf2XZBVqkOMeta } from "/var/www/website/frontend/pages/winkelwagen/index.vue?macro=true";
import { default as probleem0qDXOjn4geMeta } from "/var/www/website/frontend/pages/winkelwagen/probleem.vue?macro=true";
import { default as stap28kv9FncqQiMeta } from "/var/www/website/frontend/pages/winkelwagen/stap2.vue?macro=true";
import { default as stap3ewotDpIfaDMeta } from "/var/www/website/frontend/pages/winkelwagen/stap3.vue?macro=true";
import { default as stap4SwiLBKzXYwMeta } from "/var/www/website/frontend/pages/winkelwagen/stap4.vue?macro=true";
import { default as stap5ZHZDMrV9TmMeta } from "/var/www/website/frontend/pages/winkelwagen/stap5.vue?macro=true";
import { default as _91_46_46_46query_93JwrK99n1YwMeta } from "/var/www/website/frontend/pages/zoeken/[...query].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/[...slug].vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/var/www/website/frontend/pages/cookies.vue")
  },
  {
    name: "cursus-opleiding-slug",
    path: "/cursus-opleiding/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/cursus-opleiding/[...slug].vue")
  },
  {
    name: "cursus-opleiding",
    path: "/cursus-opleiding",
    component: () => import("/var/www/website/frontend/pages/cursus-opleiding/index.vue")
  },
  {
    name: "Frontpage",
    path: "/",
    meta: indexe8u1OeSfvKMeta || {},
    component: () => import("/var/www/website/frontend/pages/index.vue")
  },
  {
    name: "inloggen-check",
    path: "/inloggen/check",
    component: () => import("/var/www/website/frontend/pages/inloggen/check.vue")
  },
  {
    name: "inloggen",
    path: "/inloggen",
    component: () => import("/var/www/website/frontend/pages/inloggen/index.vue")
  },
  {
    name: "jgz-slug",
    path: "/jgz/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/jgz/[...slug].vue")
  },
  {
    name: "jgz",
    path: "/jgz",
    component: () => import("/var/www/website/frontend/pages/jgz/index.vue")
  },
  {
    name: "maa-slug",
    path: "/maa/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/maa/[...slug].vue")
  },
  {
    name: "maa",
    path: "/maa",
    component: () => import("/var/www/website/frontend/pages/maa/index.vue")
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/nieuws/[...slug].vue")
  },
  {
    name: "nieuws-categorie-slug",
    path: "/nieuws/categorie/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/nieuws/categorie/[...slug].vue")
  },
  {
    name: "nieuws",
    path: "/nieuws",
    component: () => import("/var/www/website/frontend/pages/nieuws/index.vue")
  },
  {
    name: "nieuws-tag-slug",
    path: "/nieuws/tag/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/nieuws/tag/[...slug].vue")
  },
  {
    name: "nt2-slug",
    path: "/nt2/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/nt2/[...slug].vue")
  },
  {
    name: "nt2",
    path: "/nt2",
    component: () => import("/var/www/website/frontend/pages/nt2/index.vue")
  },
  {
    name: "studiewijzer-slug",
    path: "/studiewijzer/:slug(.*)*",
    component: () => import("/var/www/website/frontend/pages/studiewijzer/[...slug].vue")
  },
  {
    name: "studiewijzer",
    path: "/studiewijzer",
    component: () => import("/var/www/website/frontend/pages/studiewijzer/index.vue")
  },
  {
    name: "winkelwagen-aanmelden",
    path: "/winkelwagen/aanmelden",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/aanmelden.vue")
  },
  {
    name: "winkelwagen-afrekenen",
    path: "/winkelwagen/afrekenen",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/afrekenen.vue")
  },
  {
    name: "winkelwagen-bedankt",
    path: "/winkelwagen/bedankt",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/bedankt.vue")
  },
  {
    name: "winkelwagen-geannuleerd",
    path: "/winkelwagen/geannuleerd",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/geannuleerd.vue")
  },
  {
    name: "winkelwagen-geweigerd",
    path: "/winkelwagen/geweigerd",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/geweigerd.vue")
  },
  {
    name: "winkelwagen",
    path: "/winkelwagen",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/index.vue")
  },
  {
    name: "winkelwagen-probleem",
    path: "/winkelwagen/probleem",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/probleem.vue")
  },
  {
    name: "winkelwagen-stap2",
    path: "/winkelwagen/stap2",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/stap2.vue")
  },
  {
    name: "winkelwagen-stap3",
    path: "/winkelwagen/stap3",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/stap3.vue")
  },
  {
    name: "winkelwagen-stap4",
    path: "/winkelwagen/stap4",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/stap4.vue")
  },
  {
    name: "winkelwagen-stap5",
    path: "/winkelwagen/stap5",
    component: () => import("/var/www/website/frontend/pages/winkelwagen/stap5.vue")
  },
  {
    name: "zoeken-query",
    path: "/zoeken/:query(.*)*",
    component: () => import("/var/www/website/frontend/pages/zoeken/[...query].vue")
  }
]